import { LimitDropdown, PageButton } from './PaginationControls';
import { IconChevronLeft, IconChevronRight } from '../incidents/icons';

interface OffsetPaginationProps {
  offset: number;
  limit: number;
  /** Nombre d'éléments de la page courante — l'API ne renvoie pas de total. */
  pageSize: number;
  onOffsetChange: (offset: number) => void;
  onLimitChange?: (limit: number) => void;
}

/** Pagination `offset` / `limit` sans total : « suivant » reste actif tant que la page est pleine. */
export const OffsetPagination = ({ offset, limit, pageSize, onOffsetChange, onLimitChange }: OffsetPaginationProps) => {
  const start = pageSize === 0 ? 0 : offset + 1;
  const end = offset + pageSize;

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-4 text-sm text-zinc-500">
        {onLimitChange ? <LimitDropdown value={limit} onChange={onLimitChange} /> : null}
        <span className="font-mono tabular-nums">{pageSize === 0 ? 'Aucun résultat' : `${start}–${end}`}</span>
      </div>

      <div className="flex items-center gap-1">
        <PageButton onClick={() => onOffsetChange(Math.max(0, offset - limit))} disabled={offset === 0}>
          <IconChevronLeft width={14} height={14} />
          <span>Précédent</span>
        </PageButton>
        <PageButton onClick={() => onOffsetChange(offset + limit)} disabled={pageSize < limit}>
          <span>Suivant</span>
          <IconChevronRight width={14} height={14} />
        </PageButton>
      </div>
    </div>
  );
};
